import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = "https://ffmqw31y7k.execute-api.us-east-1.amazonaws.com/pdf";
const API_KEY = "154122054";

const headers = { "x-api-key": API_KEY, "Content-Type": "application/json" };

const ViewPDFs = () => {
  const { id } = useParams(); // Get PDF ID from URL
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const response = await axios.get(`${API_URL}/${id}`, { headers });
        setPdfUrl(response.data.s3Url); // ✅ Fixed: Use `s3Url`
        setLoading(false);
      } catch (error) {
        console.error("Error fetching PDF:", error);
        setLoading(false);
      }
    };

    fetchPdf();
  }, [id]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-white mb-4">

      {/* ✅ Loading Animation */}
      {loading ? (
        <div className="flex justify-center items-center min-h-[50vh]">
          <div className="w-16 h-16 border-4 border-t-red-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : pdfUrl ? (
        <iframe
          src={pdfUrl}
          className="w-full max-w-4xl h-[90vh] border-2 border-white rounded-lg"
          title="PDF Viewer"
        ></iframe>
      ) : (
        <p className="text-red-500">PDF not found</p>
      )}
    </div>
  );
};

export default ViewPDFs;
